var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.personalBest)?_c('span',{staticClass:"text-bold"},[_vm._v("PB! 🙌")]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eab1ee6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Utility/Labels/PersonalBestLabel.vue
// module id = 852
// module chunks = 0 1